import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { IonContent, Platform } from '@ionic/angular';

import { Navigator } from 'src/app/services/routing/navigator';
import { DepositMainLabels } from 'src/app/interfaces/deposit-main-labels';
import { DepositMainModel } from 'src/app/models/deposit-models';
import { CashierService } from 'src/app/services/cashier/cashier.service';
import { CashierContentService } from 'src/app/services/cashier/cashier-content.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { DepositService } from 'src/app/services/cashier/deposit.service';
import { EventsService } from 'src/app/services/event/event.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { CashierBase } from '../../cashier-base/cashier-base';
import { isUndefined } from 'src/app/services/codeUtils';
import { DEPOSIT_PATTERN } from 'src/app/services/customFormValidators';

declare var window: any;

import BTClient from "braintree-web/client";
import BTVenmo from "braintree-web/venmo";

@Component({
  selector: 'app-deposit-venmo',
  templateUrl: './deposit-venmo.component.html',
  styleUrls: ['./deposit-venmo.component.scss'],
})
export class DepositVenmoComponent extends CashierBase implements OnInit {

  @ViewChild(IonContent, { static: false }) content: IonContent;

  @Input() public navigateBackPage: any;

  public allowDesktop: boolean;
  public bonusCode: string;
  public braintreeToken: any;
  public customer: any;
  public defaultAmounts: any = [];
  public error = null;
  public labels: DepositMainLabels;
  public minAmount: any;
  public paymentType: any = [];
  public paymentRequestID: any;
  public vendorLogoUrl: string = '';
  public buttonDisabled: boolean = false;

  public depositForm: FormGroup;
  public amount: AbstractControl;
  public storeAmount;

  constructor(
    public cashierService: CashierService,
    public cashierContentService: CashierContentService,
    public config: ConfigService,
    public depositService: DepositService,
    public events: EventsService,
    public navigator: Navigator,
    public platform: Platform,
    public UserSessionService: UserSessionService,
    public successMessageService: SuccessMessageService,
  ) {
    super();
    this.successMessageService.clearMessage();
    this.labels = new DepositMainModel();
    this.getCustomer();
  }

  ngOnInit() {

    this.allowDesktop = this.config.getConfig().BRAINTREE_ALLOW_DESKTOP ? this.config.getConfig().BRAINTREE_ALLOW_DESKTOP : true;

    this.cashierContentService.bonusOfferValue.subscribe(res => this.bonusCode = res);

    this.depositForm = new FormGroup({
      amount: new FormControl({ value: '', disabled: false }, { validators: [Validators.pattern(DEPOSIT_PATTERN), Validators.required], updateOn: 'change' }),
    });

    this.amount = this.depositForm.get("amount");
  }

  ngAfterViewInit() {
    this.cashierContentService.getPageConfig('venmo').then((response: DepositMainLabels) => {
      this.labels = response;
    });
  }

  ionViewDidEnter() {
    this.successMessageService.clearMessage();
    this.cashierService.getActivePaymentTypes('VEN').subscribe((response: any) => {
      if (response.result) {
        this.paymentType = response.payload;
        if (!isUndefined(this.paymentType)) {
          this.minAmount = this.paymentType[0].min;
          this.defaultAmounts = this.cashierContentService.getDefaultPayments(this.paymentType, 0);
        }
      }
    }, (error) => console.log("Type category error", error));
  }

  private getCustomer() {
    this.UserSessionService.getCustomerSubscription().then((customerSubscription) => {
      customerSubscription.subscribe((customer) => {
        this.customer = customer;
      });
    });
  }

  public selectedDepositBonusOffer($event): void {
    this.bonusCode = $event.selectedbonusOffer.campaign_code;
  }

  public onAmountSelected(data) {
    return this.depositForm.get('amount').setValue(data);
  }

  onSubmit() {
    this.buttonDisabled = true;
    this.error = null;
    this.successMessageService.clearMessage();


    let depositFormObj: any = this.depositForm.value;
    const amount = this.depositForm.get('amount').value;
    depositFormObj.amount = amount;
    depositFormObj.payment_type_code = 'VEN';
    depositFormObj.currency_code = this.customer.preferredCurrency.currencyCode;
    if (this.bonusCode != "") depositFormObj.bonusCode = this.bonusCode;

    this.cashierService.callDeposit(depositFormObj).subscribe((response: any) => {
      setTimeout(() => {
        this.buttonDisabled = false;
      }, 1500);

      this.storeAmount = this.depositForm.get('amount').value;
      this.depositForm.get('amount').patchValue('');
      this.depositForm.get('amount').markAsPristine();

      if (!isUndefined(response) && !!response.result) {
        this.paymentRequestID = response.payload.paymentRequestID;

        // Added to show threshold popup when amound of deposits cross the threshold limit. STRDSTUSA-1591
        let exceededDepositLimit = false;

        if (response.payload) {
          if ('hasExceededDepositLimit' in response.payload) {
            exceededDepositLimit = response.payload.hasExceededDepositLimit;
          }
        }


        if (exceededDepositLimit) {
          return this.navigator.navigateTo('DepositThresholdComponent', {}, { status: true, amount: this.amount.value, customerId: this.cashierService.customer.customerId });
        } else {
            this.depositService.getBraintreeToken(amount, this.paymentRequestID).subscribe(
              (response: any) => {
                if (!isUndefined(response) && !!response.result) {
                  this.braintreeToken = response.payload.token;
                  this.createBraintreeUI();
                }
              }
            );
        }

        return;
      }

      return this.navigator.navigateTo('DepositSuccessFailureComponent', {}, { status: false, message: 'Error! Connecting Venmo' });
    }, error => {
      this.buttonDisabled = false;
      this.error = this.handleError(error);
      this.content.scrollToTop();
      this.navigator.navigateTo('DepositSuccessFailureComponent', {}, { status: false, message: this.error.error_message });
    });
  }

  async createBraintreeUI() {

    let message: string;
    try {

      try {

        const payload = await (this.platform.is('cordova') ? this.callOutToVenmoApp() : this.initVenmoWeb());
        this.confirmVenmoDeposit(payload);

      } catch (error) {
        switch (error.code) {
          case 'VENMO_APP_CANCELED':
            message = 'User canceled Venmo flow.'
            break;
          case 'VENMO_CANCELED':
            message = 'User canceled Venmo, or Venmo app is not available.'
            break;
          case 'VENMO_DESKTOP_CANCELED':
            message = 'User canceled Venmo flow.'
            break;
          default:
            console.error('Error!', JSON.stringify(error, null, 2));
            message = error.message;
            break;
        }

        this.navigator.navigateTo('DepositSuccessFailureComponent', {}, { status: false, message: message });

      }

    } catch (error) {
      this.error = this.handleError(error);
      this.content.scrollToTop(10);
    }
  }

  async initVenmoWeb() {
    const clientInstance = await BTClient.create({
      authorization: this.braintreeToken
    });

    const venmoInstance = await BTVenmo.create({
      client: clientInstance,
      allowDesktop: this.allowDesktop,
      PaymentMethodUsage: 'multi_use'
    });

    if (!venmoInstance.isBrowserSupported()) {
      console.error("Venmo is not supported on this browser");
      return Promise.reject("Venmo is not supported on this browser");
    }

    return venmoInstance.tokenize();
  }

  public callOutToVenmoApp() {
    var url = this.config.getConfig().LOBBY_URL + '/assets/venmo/popupBridge.html';
    //var url='/assets/venmo/popupBridge.html';

    var params = {
      //      key: this.braintreeToken,
      t: Date.now(),
    };

    var queryString = Object.keys(params).map((key) => {
      return encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
    }).join('&');

    return new Promise((resolve, reject) => {
      var windowRef = window.cordova.InAppBrowser.open(url + '?' + queryString, '_blank', 'location=no');

      windowRef.addEventListener('loaderror', event => {
        console.log('MEEP: loaderror');
      });

      windowRef.addEventListener('loadstart', event => {
        console.log('MEEP: loadstart');
      });

      windowRef.addEventListener('exit', event => {
        console.log('MEEP: exit');
      });

      windowRef.addEventListener('loadstop', (evt: any) => {
        console.log('MEEP: loadstop');
        windowRef.executeScript({ code: "initializeBraintree( '" + this.braintreeToken + "');" });
        var id = setInterval(() => {
          windowRef.executeScript({ code: "window.__venmo_payload" }, result => {
            if (result[0]) {
              windowRef.close();
              clearInterval(id);
              var venmo_result = JSON.parse(result[0]);
              resolve(venmo_result);
            }
          });
        }, 50);
      });

    });
  }

  private confirmVenmoDeposit(payload) {

    const venmoPayload: any = JSON.stringify(payload.details);
    const nonce: any = payload.nonce;

    if (payload && Object.keys(payload).length === 0 && Object.getPrototypeOf(payload) === Object.prototype) {
      const message = 'User canceled Venmo flow.';
      this.navigator.navigateTo('DepositSuccessFailureComponent', {}, { status: false, message: message });
      return false;
    }

    this.depositService.callBraintreeConfirm(nonce, this.paymentRequestID, venmoPayload).subscribe((response) => {
      if (!isUndefined(response) && !!response.result) {
        let successMessage: string = '$' + this.storeAmount + " has been added to your account.";
        /*let depositEventData = {
          customerId: this.cashierService.customer.customerId,
          amount:     this.amount.value,

          transaction_id: this.paymentRequestID,
          paymentMethod: "VENMO"
        }
        setTimeout(() => this.events.publish('event:deposit', depositEventData ), 2000);*/
        this.navigator.navigateTo('DepositSuccessFailureComponent', {}, { status: true, message: successMessage });

        let exceededDepositLimit = false;

        if (response.payload) {
          if ('hasExceededDepositLimit' in response.payload) {
            exceededDepositLimit = response.payload.hasExceededDepositLimit;
          }
        }


        if (exceededDepositLimit) {
          return this.navigator.navigateTo('DepositThresholdComponent', {}, { status: true, amount: this.amount.value, customerId: this.cashierService.customer.customerId });
        } else {
          return this.navigator.navigateTo("DepositSuccessFailureComponent", {}, { status: true, message: successMessage });
        }
      }
    }, error => {
      this.error = this.handleError(error);
      this.navigator.navigateTo('DepositSuccessFailureComponent', {}, { status: false, message: this.error.error_message });
    });
  }

  onBack = () => {
    this.cashierContentService.onBackHandler(this.navigateBackPage);
  }

}
